var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftLightTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666832 14.0007C0.666832 10.4644 2.07159 7.07305 4.57207 4.57256C7.07256 2.07208 10.4639 0.66732 14.0002 0.66732C15.7511 0.66732 17.4849 1.0122 19.1026 1.68226C20.7203 2.35232 22.1901 3.33445 23.4283 4.57256C25.9287 7.07305 27.3335 10.4644 27.3335 14.0007C27.3335 17.5369 25.9287 20.9283 23.4283 23.4287C20.9278 25.9292 17.5364 27.334 14.0002 27.334C12.2492 27.334 10.5154 26.9891 8.89772 26.319C7.28004 25.649 5.81019 24.6669 4.57207 23.4287C3.33396 22.1906 2.35183 20.7208 1.68177 19.1031C1.01171 17.4854 0.666832 15.7516 0.666832 14.0007ZM22.0002 12.6673L11.3335 12.6673L16.0002 8.00065L14.1068 6.10732L6.2135 14.0007L14.1068 21.894L16.0002 20.0007L11.3335 15.334L22.0002 15.334V12.6673Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLightTheme);
export default __webpack_public_path__ + "static/media/arrowLeftLightTheme.431450004f996ed80d34f9809cbfdd48.svg";
export { ForwardRef as ReactComponent };